export default "/fonts/vendor/balm-ui/material-icons-two-tone.woff2?4cd0b540933d1628c22470b965ee367b";